import {
  CouponIcon,
  ShopInfo_representative_coupon,
  ShopInfo_representative_coupon_v2,
  ShopUxUbl,
} from '@domains/storehome-common';

interface CouponDownloadClickProps {
  link?: string;
  ubl?: ShopUxUbl | null;
}

interface Props {
  shop_id: string;
  representative_coupon: ShopInfo_representative_coupon | null;
  representative_coupon_v2: ShopInfo_representative_coupon_v2 | null;
  onClick?: (params: CouponDownloadClickProps) => void;
}

export const SelectedCoupon = ({ representative_coupon, representative_coupon_v2, shop_id, onClick }: Props) => {
  if (representative_coupon_v2?.main_title.html?.normal) {
    return (
      <CouponIcon
        link={representative_coupon_v2.link_url}
        title={{
          is_html: true,
          text: representative_coupon_v2.main_title.html?.normal,
        }}
        onClick={onClick}
      />
    );
  }

  if (representative_coupon) {
    return (
      <CouponIcon
        link={`/coupon/box/${shop_id}`}
        title={{ is_html: true, text: representative_coupon.title.replace('FA6EE3', 'FF4C34') }}
        onClick={onClick}
      />
    );
  }

  return null;
};
